import z from "zod";

import { item } from "../../authoring.js";
import {
  actionLevel,
  actionLevelOrNotApplicable,
  actionLevelOrUnknown,
  yesNo,
} from "./responseSets.js";

/**
 * A small instrument standing in for real content.
 *
 * Placeholder: the items and groups here exercise every shape the model has —
 * a mandatory group, an optional one, a mandatory item, an optional item, and
 * three response sets — so the machinery around them can be reviewed and
 * tested. They are not anybody's assessment content, and the real content
 * arrives as its own modules under its own family.
 */

export const name = ["sample", "core", "1.0", "r1"] as const;

/** The groups, exported so a collector names one with the compiler checking it. */
export const groups = {
  life_functioning: "life_functioning",
  trauma: "trauma",
} as const;

export const items = {
  school_attendance: "school_attendance",
  school_behaviour: "school_behaviour",
  family_history: "family_history",
  adjustment_to_trauma: "adjustment_to_trauma",
} as const;

/** Every key an earlier version asked and this one does not. The first version retires nothing. */
export const retiredItems = [] as const;

const lifeFunctioning = z
  .object({
    // Not applicable where the young person is not in education, which is a
    // different fact from a level of need.
    ...item(items.school_attendance, actionLevelOrNotApplicable)
      .withComment()
      .build(),
    ...item(items.school_behaviour, actionLevel).withComment().build(),
    // Optional, so a collector may ask it only where something earlier makes it
    // relevant, and a document without it is still valid.
    ...item(items.family_history, yesNo).optional().withComment().build(),
  })
  .strict();

const trauma = z
  .object({
    ...item(items.adjustment_to_trauma, actionLevelOrUnknown)
      .withComment()
      .build(),
  })
  .strict();

export const schema = z
  .object({
    [groups.life_functioning]: lifeFunctioning,
    // An optional group: a module, asked only where a collector's own rule
    // opens it, and absent from a valid document otherwise.
    [groups.trauma]: trauma.optional(),
  })
  .strict();
